const utils = require('../../../lib/utils')

module.exports = {
	model: {
		dirtyAssignedMailingLists: [],
		dirtyAssignedMailingListsInEffect: false,
		dirtyCreations: {},
		dirtyDeletions: {},
		newlyCreatedMailingListAssignmentIndex: -1
	},

	events: {
		open: {
			type: 'click',
			action: function(event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);

				if($target.closest('button').length > 0) {
					var resourceData = self.model['resource-picker-data'] || {};
					var mailingLists = [];
					if(self.model.dirtyAssignedMailingListsInEffect) {
						mailingLists = self.model.dirtyAssignedMailingLists;
					} else if (self.model.selectedMailingLists) {
						mailingLists = self.model.selectedMailingLists;
					}
					utils.refReplace(resourceData, { dirtyAssignedMailingLists: mailingLists });

					self.performAndStoreAction(
						'mailingListPickerModal',
						self.prepareAction(
							'showMailingListPicker',
							undefined,
							{
								mailingLists: resourceData
							}
						)
					);
				}
			}
		}
	},

	methods: {
		dataDealer: function(){
			var self = this;
			self.model.mailingLists = [];
			self.model.selectedMailingLists = [];
			self.model.newsletterPropertiesForm = null;
			self.model.newsletterID = null;
			self.model.dirtyAssignedMailingListsInEffect = false;
			self.closest('base_form_form', function(form){
				self.model.newsletterPropertiesForm = form;
				var newsletterData = (form.resourceData || {}).data || {};
				self.model.mailingLists = ((newsletterData.children || {}).nl_newsletters_mailingLists || {}).data || [];
				self.model.newsletterID = (newsletterData.attributes || {}).newsletterID || (newsletterData.attributes || {}).id;
				self.model.newlyCreatedMailingListAssignmentIndex = self.model.mailingLists.length;
				for(var ml in self.model.mailingLists){
					self.model.selectedMailingLists.push(((self.model.mailingLists[ml] || {}).attributes || {}).mailingListID)
				}
			});
		}
	},

	hooks: {
		async onDecision($element, options){
			// decisionComponent: <selectRouteTrees>,
			// decisionType: 'submit',
			// decisionOptions: <decisionOptions>,
			// data: <listOfSelectedEntities> [{<properties>, ...}, ...]
			var self = this;
			var mailingListID;
			options = options || {};

			switch(options.decisionType){
				case 'decisionComponent':
					var bd, baseData = (self.model['resource-picker-data'] || {}).data || [], bdMailingListID;
					var isDirtyPresent = false;
					var isDataPresent = false;
					var isDataPresentDataIndex;
					var dataIndex;
					var nrOfChangedEntries = 0;

					for(bd in baseData){
						bdMailingListID = (baseData[bd].attributes || {}).mailingListID;
						isDirtyPresent = utils.indexOf(self.model.dirtyAssignedMailingLists, bdMailingListID) > -1;
						isDataPresent = false;
						isDataPresentDataIndex = -1;
						for(dataIndex in self.model.mailingLists){
							if(((self.model.mailingLists[dataIndex] || {}).attributes || {}).mailingListID == bdMailingListID){
								isDataPresentDataIndex = dataIndex;
								isDataPresent = true;
								break;
							}
						}

						if(isDirtyPresent){
							if(!isDataPresent){
								// add
								if(!self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID]){
									self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID] = self.model.newlyCreatedMailingListAssignmentIndex;
									self.model.newsletterPropertiesForm.relationFieldToModel({
										type: 'create',
										value: {
											attributes: {
												mailingListID: 		bdMailingListID,
												newsletterID: 		self.model.newsletterID
											}
										},
										relationConfig: {
											subFormAliasContainer: 'children',
											subFormAlias: 'nl_newsletters_mailingLists'
										},
										relationDataIndex: 	self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID]
									});
									self.model.newlyCreatedMailingListAssignmentIndex++;
								}
								nrOfChangedEntries++;
							} else if (self.model.dirtyDeletions[self.model.newsletterID + '_' + bdMailingListID]) {
								// remove deletion
								isDataPresentDataIndex = self.model.dirtyDeletions[self.model.newsletterID + '_' + bdMailingListID];
								delete self.model.dirtyDeletions[self.model.newsletterID + '_' + bdMailingListID];
								self.model.newsletterPropertiesForm.relationFieldToModel({
									type: 'keepNull',
									// value: self.model.mailingLists[isDataPresentDataIndex],
									value: null,
									relationConfig: {
										subFormAliasContainer: 'children',
										subFormAlias: 'nl_newsletters_mailingLists'
									},
									relationDataIndex: isDataPresentDataIndex
								});
							}

						} else if(!isDirtyPresent) {
							if(isDataPresent){
								// delete
								if(!self.model.dirtyDeletions[self.model.newsletterID + '_' + bdMailingListID]){
									self.model.dirtyDeletions[self.model.newsletterID + '_' + bdMailingListID] = isDataPresentDataIndex;
									self.model.newsletterPropertiesForm.relationFieldToModel({
										type: 'delete',
										value: self.model.mailingLists[isDataPresentDataIndex],
										relationConfig: {
											subFormAliasContainer: 'children',
											subFormAlias: 'nl_newsletters_mailingLists'
										},
										relationDataIndex: isDataPresentDataIndex
									});
								}
								nrOfChangedEntries++;
							} else if(self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID]){
								// remove creation
								isDataPresentDataIndex = self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID];
								delete self.model.dirtyCreations[self.model.newsletterID + '_' + bdMailingListID];
								self.model.newsletterPropertiesForm.relationFieldToModel({
									type: 'keepNull',
									value: null,
									relationConfig: {
										subFormAliasContainer: 'children',
										subFormAlias: 'nl_newsletters_mailingLists'
									},
									relationDataIndex: isDataPresentDataIndex
								});
							}
						}
					}

					if(nrOfChangedEntries > 0){
						self.model.newsletterPropertiesForm.setDirty();
					} else {
						self.model.newsletterPropertiesForm.setClean();
					}

					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						await options.decisionComponent.hide()
					}
					break;

				case 'submit':
					self.model.dirtyAssignedMailingListsInEffect = true;
					self.model.dirtyAssignedMailingLists = [];
					utils.forEach(options.data || [], function(mailingList){
						if((mailingListID = (mailingList || {}).mailingListID || (mailingList || {}).id)){
							self.model.dirtyAssignedMailingLists.push(mailingListID);
						}
					});
					break;

				case 'cancel':
				default:
					this.model.dirtyAssignedMailingLists = [];
					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						await options.decisionComponent.hide()
					}
					break;
			}
		}
	}
}